// GUIA DE LEITURA — BottomBar.js
// Rodapé do site com contactos, redes sociais e ligação à história.
// Comentários explicativos adicionados para estudo; a lógica original foi mantida.
// Conceitos: props = dados recebidos; state = dados que mudam; hook = função React reutilizável.

import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

// Define um componente ou função auxiliar. Os parâmetros entre parênteses são os dados que recebe.
function BottomBar() {
  return (
    <footer className="gd-footer">
      <div className="gd-footer-inner">
        <div className="gd-footer-contact">
          <a href="mailto:gdfeitos1986@gmail.com">
            <FaEnvelope />
            <span>gdfeitos1986@gmail.com</span>
          </a>

          <a
            href="https://maps.app.goo.gl/nLootwt9FRfdF6Cx6"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaMapMarkerAlt />
            <span>Rua do Alto das Cruzes - Feitos</span>
          </a>
        </div>

        <div className="gd-footer-brand">
          <span className="gd-footer-name">GRUPO DESPORTIVO DOS FEITOS</span>
          <span className="gd-footer-caption">Desde 1986</span>
          <Link className="gd-footer-history" to="/historia-clube">Conhece a nossa história →</Link>
        </div>

        <div className="gd-footer-socials">
          <a
            href="https://www.facebook.com/GDFeitos/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook do GD Feitos"
          >
            <FaFacebook />
          </a>

          <a
            href="https://www.instagram.com/gdfeitos/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram do GD Feitos"
          >
            <FaInstagram />
          </a>
        </div>
      </div>

      <style>{`
        .gd-footer {
          width: 100%;
          color: #f5f5f5;
          background: linear-gradient(110deg, #17191c, #24272b);
          border-top: 1px solid rgba(255, 255, 255, 0.12);
          box-sizing: border-box;
          position: relative;
          z-index: 5;
        }

        .gd-footer-inner {
          width: 100%;
          max-width: none;
          min-height: 88px;
          margin: 0 auto;
          padding: 18px 32px;
          box-sizing: border-box;
          display: grid;
          grid-template-columns: 1fr auto 1fr;
          align-items: center;
          gap: 24px;
        }

        .gd-footer-contact {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 9px;
        }

        .gd-footer-contact a {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          color: #c9cbd0;
          font-size: 12px;
          text-decoration: none;
          transition: color 0.2s ease;
        }

        .gd-footer-contact a svg {
          color: #f5f5f5;
          font-size: 13px;
          flex-shrink: 0;
        }

        .gd-footer-contact a:hover {
          color: #ffffff;
        }

        .gd-footer-brand {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 5px;
          text-align: center;
        }

        .gd-footer-name {
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 1.5px;
          white-space: nowrap;
        }

        .gd-footer-caption {
          color: #a8abb1;
          font-size: 10px;
          letter-spacing: 2px;
          text-transform: uppercase;
        }

        .gd-footer-history{font-size:11px;color:#c9cbd0;text-decoration:none;margin-top:4px;transition:color .2s}
        .gd-footer-history:hover{color:#fff;text-decoration:underline}
        .gd-footer-socials {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          gap: 10px;
        }

        .gd-footer-socials a {
          width: 38px;
          height: 38px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid rgba(255, 255, 255, 0.17);
          border-radius: 50%;
          color: #ffffff;
          background: rgba(255, 255, 255, 0.04);
          font-size: 17px;
          text-decoration: none;
          transition: background 0.2s ease, transform 0.2s ease;
        }

        .gd-footer-socials a:hover {
          background: rgba(255, 255, 255, 0.15);
          transform: translateY(-2px);
        }

        @media (max-width: 700px) {
          .gd-footer-inner {
            grid-template-columns: 1fr auto;
            padding: 18px 20px;
            gap: 18px;
          }

          .gd-footer-contact {
            grid-column: 1 / -1;
            align-items: center;
            text-align: center;
          }

          .gd-footer-brand {
            align-items: flex-start;
            text-align: left;
          }

          .gd-footer-name {
            font-size: 10px;
            letter-spacing: 1px;
            white-space: normal;
          }

          .gd-footer-socials {
            justify-content: flex-end;
          }
        }

        @media (max-width: 380px) {
          .gd-footer-inner {
            padding: 16px 12px;
          }

          .gd-footer-contact a {
            font-size: 11px;
          }

          .gd-footer-socials {
            gap: 6px;
          }

          .gd-footer-socials a {
            width: 34px;
            height: 34px;
          }
        }
      `}</style>
    </footer>
  );
}

export default BottomBar;